export default "__VITE_ASSET__UuA39pyt__"